<template>
  <div class="page">
    <div class="brand">
      <img v-if="logo" class="logo" :src="logo" alt="">
      <div v-else class="logo logo-fallback"><van-icon name="shop-o" /></div>
      <div class="name">{{ companyName || '会员中心' }}</div>
    </div>
    <div class="title">会员登录</div>
    <van-form @submit="onSubmit">
      <van-field v-model="form.phone" name="phone" label="手机号" maxlength="11" placeholder="请输入手机号" :rules="[{ required: true, message: '请输入手机号' }]" />
      <van-field v-model="form.password" name="password" type="password" label="密码" placeholder="请输入密码" :rules="[{ required: true, message: '请输入密码' }]" />
      <div class="btn"><van-button round block type="info" native-type="submit">登录</van-button></div>
    </van-form>
    <div class="link" @click="goRegister">没有账号，去注册</div>
  </div>
</template>

<script>
import { getShareConfig, login, saveAuth } from '../api'
import { assetUrl } from '../utils/asset'

export default {
  data() {
    return { form: { phone: '', password: '' }, logo: '', companyName: '' }
  },
  created() {
    getShareConfig().then(res => {
      const data = res.data || {}
      this.logo = assetUrl(data.logo)
      this.companyName = data.companyName || ''
    })
  },
  methods: {
    onSubmit() {
      login(this.form).then(res => {
        saveAuth(res.data)
        const code = this.$route.query.code
        if (code) {
          this.$toast('你已是会员')
        }
        this.$router.replace('/')
      })
    },
    goRegister() {
      this.$router.push({ path: '/register', query: this.$route.query })
    }
  }
}
</script>

<style scoped>
.page { padding: 28px 16px; }
.brand { text-align: center; margin-bottom: 28px; }
.logo { width: 72px; height: 72px; border-radius: 18px; object-fit: cover; display: block; margin: 0 auto; }
.logo-fallback { background: #e7f3ef; color: #1f6f5b; font-size: 32px; display: flex; align-items: center; justify-content: center; }
.name { margin-top: 12px; font-size: 18px; font-weight: 600; }
.title { font-size: 16px; color: #666; margin-bottom: 16px; }
.btn { margin: 24px 16px 0; }
.link { text-align: center; color: #1989fa; margin-top: 16px; }
</style>
